//  Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {AlertDialogComponent} from '../../dialogs/alert/alert.component';
import {MatDialog} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-verify-email',
    templateUrl: './verify-email.component.html',
    styleUrls: ['./verify-email.component.scss'],
    standalone: false
})
export class VerifyEmailComponent implements OnInit {
  style = {
    'width': '1050px',
    'margin': '100px auto'
  }
  address = '';

  fOK: string;
  fSuccess: string;
  fSuccessMessage: string;

  constructor(
      private router: Router,
      private route: ActivatedRoute,
      private dialog: MatDialog,
      private translate: TranslateService,
  ) {
    const keys = ['ALERT_OK', 'SUCCESS', 'VEM_SUCCESS_MESSAGE'];
    this.translate.get(keys).subscribe(vals => {
      this.fOK = vals['ALERT_OK'];
      this.fSuccess = vals['SUCCESS'];
      this.fSuccessMessage = vals['VEM_SUCCESS_MESSAGE'];
    });
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params: ParamMap) => {
      this.address = decodeURIComponent(params.get('address'));
    });
  }

  onSuccess() {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '450px',
      data: {
        title: this.fSuccess,
        content: this.fSuccessMessage,
        acceptBtnName: this.fOK,
        showRejectBtn: false,
      },
    });
    dialogRef.afterClosed().subscribe(
        () => {
          this.router.navigate(['login']);
        }
    );
  }
}
